<template>
  <span>
    <div class="pa-2">
      <template v-if="baseUrl">
        <img
          ref="answer"
          style="width: 100%; max-width: 255px"
          :src="baseUrl.replace('?_ignored=', '')"
        />
      </template>

      <div v-if="productCatalogDataViewer">
        <template
          v-if="
            productCatalogDataViewer.is_management_product_to_cart_comment &&
            Boolean(productCatalogDataViewer.is_management_product_to_cart_comment) === true
          "
        >
          <!-- <pre>{{ JSON.stringify(productCatalogDataViewer, null, 4) }}</pre> -->
          <div style="display: flex; flex-direction: column">
            <div style="display: flex; flex-direction: row">
              <ViewProductCatalogCartSummaryViewer
                v-model="productCatalogDataViewer"
              ></ViewProductCatalogCartSummaryViewer>
              <div>
                <div>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        fab
                        outline
                        color="primary"
                        class="extra-small"
                        v-on="on"
                        @click="
                          () => {
                            show = true
                            onClick()
                            isManageProductToCart = true
                          }
                        "
                      >
                        <em class="fa fa-pencil-alt middle" />
                      </v-btn>
                    </template>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>

          <!-- <div
            class="text-xs-left pa-2 mb-2"
            style="border: 1px solid #eee; float: left; border-radius: 10px"
          >
            <div class="pa-2">
              <div class="primary--text mb-2">
                {{ $t(`product_catalog.${productCatalogDataViewer.type}_product_to_cart`) }}
              </div>
              <div
                v-for="(product, productIndex) in productCatalogDataViewer.products"
                :key="productIndex"
              >
                <div>
                  {{ product.product_name }} ({{ product.option }})
                  <span>x {{ product.quantity }}</span>
                </div>
              </div>
              <div class="mt-2">
                {{ $t('product_catalog.is_update_product_stock') }} :
                <span class="primary--text">{{
                  productCatalogDataViewer.is_update_product_stock ? $t('yes') : $t('no')
                }}</span>
              </div>
            </div>
            <div class="clearfix"></div>
            <v-divider />
            <div class="mt-2 text-xs-center">
              <v-btn
                color="primary"
                depressed
                @click="
                  () => {
                    show = true
                    onClick()
                  }
                "
                >{{ $t('edit') }}</v-btn
              >
            </div>
          </div> -->
        </template>
        <template v-else>
          <template v-if="productCatalogDataViewer.includes('show_products_by_bot')">
            <div
              class="text-xs-center pa-2 mb-2"
              style="border: 1px solid #eee; float: left; border-radius: 10px"
            >
              <div class="py-2">
                <div class="primary--text">Show Products by Bot</div>
                <div class="grey--text caption">{{ productCatalogDataViewer }}</div>
              </div>
              <div class="clearfix"></div>
              <v-divider />
              <div class="mt-2">
                <v-btn
                  color="primary"
                  depressed
                  @click="
                    () => {
                      show = true
                      onClick()
                    }
                  "
                  >{{ $t('edit') }}</v-btn
                >
              </div>
            </div>
          </template>
          <template v-else>
            <message-viewer v-model="productCatalogDataViewer"></message-viewer>
            <div class="clearfix"></div>
            <div>
              <v-btn
                color="primary"
                depressed
                @click="
                  () => {
                    show = true
                    onClick()
                  }
                "
                >{{ $t('edit') }}</v-btn
              >
            </div>
          </template>
        </template>
      </div>

      <v-dialog v-model="show" fullscreen>
        <v-card style="overflow: hidden">
          <div style="display: flex; justify-content: center">
            <v-layout style="max-width: 1280px">
              <v-flex style="display: flex; align-items: center">
                <div class="primary--text headline pa-2">
                  {{
                    isManageProductToCart ? $t('Add/Remove to cart') : $t('product_catalog.title')
                  }}
                </div>
              </v-flex>
              <v-flex>
                <div class="text-xs-right">
                  <v-btn flat fab @click="show = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <!-- :src="`https://message-template.enterprise.zwiz.app/th/product-catalog-message?page_id=${
              selectedBot.pageid
            }&url=${locationOrigin}&t=${Date.now()}`" -->
          <!-- :src="`http://localhost:3500/th/product-catalog-message?page_id=${
              selectedBot.pageid
            }&url=${locationOrigin}&t=${Date.now()}`" -->
          <iframe
            v-if="show"
            id="iframe-product-catalog-message-edit"
            :key="reRenderKey"
            :src="productCatalogUrl"
            style="
              height: 100%;
              overflow: auto;
              width: 100%;
              border: none;
              position: absolute;
              inset: 60px 0 0;
            "
            sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
            allowfullscreen="true"
          />
        </v-card>
      </v-dialog>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('note_this_messages_will_be_shown_on_webchat') }}
    </div>
  </span>
</template>

<script>
import jsonFormatter from 'json-string-formatter'
import { mapGetters } from 'vuex'
import MessageViewer from '@/components/elements/MessageViewer'
import ViewProductCatalogCartSummaryViewer from '@/components/elements/ViewProductCatalogCartSummaryViewer'

export default {
  components: {
    MessageViewer,
    ViewProductCatalogCartSummaryViewer
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },

    isReplyComment: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      linkurl: '',
      hasLinkUrl: false,
      show: false,
      message: null,
      baseUrl: null,
      reRenderKey: 0,
      locationOrigin: '',
      isManageProductToCart: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    productCatalogUrl() {
      let baseUrl = ''
      if (window.location.hostname === 'localhost') {
        baseUrl = 'http://localhost:3500'
      } else {
        baseUrl = 'https://message-template.enterprise.zwiz.app'
      }

      const queryIsReplyComment =
        this.isReplyComment || this.isManageProductToCart ? `&is_reply_comment=true` : ''

      return `${baseUrl}/th/product-catalog-message?page_id=${
        this.selectedBot.pageid
      }${queryIsReplyComment}&url=${this.locationOrigin}&t=${Date.now()}`
    },
    productCatalogDataViewer() {
      const tempMessage = this.message

      if (tempMessage) {
        const objMessage = JSON.parse(tempMessage)
        const formatMessage = { ...objMessage }

        if (formatMessage) {
          const dataViewer = formatMessage.product_catalog_message.data

          if (formatMessage.product_catalog_message.type === 'management_product_to_cart_comment') {
            return {
              ...dataViewer,
              is_management_product_to_cart_comment: true
            }
          } else {
            if (formatMessage.product_catalog_message.type === 'show_products_by_bot') {
              return dataViewer
            } else {
              return [
                [
                  {
                    ...dataViewer,
                    ratio: 'square'
                  }
                ]
              ]
            }
          }
        }
      }

      return null
    }
  },
  watch: {
    value: function (newVal) {
      const vm = this
      vm.baseUrl = newVal.baseUrl
      vm.message = jsonFormatter.format(JSON.stringify(newVal))
    },
    show: function () {
      this.reRenderKey++
    }
  },
  mounted: function () {
    const vm = this
    vm.baseUrl = vm.value.baseUrl
    vm.message = jsonFormatter.format(JSON.stringify(vm.value))

    vm.cached_message = jsonFormatter.format(JSON.stringify(vm.value))
    vm.locationOrigin = window.location.origin
    vm.reRenderKey++
  },
  beforeDestroy() {
    window.removeEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  methods: {
    handleListenEventMessage({ event_id, data }) {
      switch (event_id) {
        case 'zwiz-product-catalog-message-cancel':
          this.onCancel()
          break
        case 'zwiz-product-catalog-message-ready':
          this.onReady()
          break
        case 'zwiz-product-catalog-message-edit':
          this.message = jsonFormatter.format(JSON.stringify(data))
          this.onSave()
          break
      }
    },
    onClick: function () {
      if (this.value) {
        this.message = JSON.stringify(this.value)
        this.show = true

        window.addEventListener(
          'message',
          (e) => {
            if (e.data) {
              this.handleListenEventMessage(e.data)
            }
          },
          false
        )
      }
    },
    onReady: function () {
      setTimeout(() => {
        if (document.querySelector('iframe#iframe-product-catalog-message-edit')) {
          const iframeProductCatalogMessageEdit = document.querySelector(
            'iframe#iframe-product-catalog-message-edit'
          )

          iframeProductCatalogMessageEdit.contentWindow.postMessage(
            {
              event_id: 'zwiz-product-catalog-message-edit',
              data: this.message
            },
            '*'
          )
        }
      }, 500)
    },
    onCancel: function () {
      this.show = false
      this.message = this.cached_message
    },
    onSave: async function () {
      const vm = this
      try {
        const tempMessage = JSON.parse(vm.message)
        const tempBubble = {
          ...tempMessage
          // type: 'product_catalog'
        }

        vm.$emit('input', tempBubble)
        vm.message = jsonFormatter.format(vm.message)
        vm.show = false
        vm.cached_message = vm.message
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentProductCatalog.vue